'use strict';

var react = require('react');
var useDebounce = require('../useDebounce/useDebounce.js');

/**
 * Wrapper around our `useDebounce` hook to debounce a value change.
 */ function useDebounceValue({ value, delay }) {
    const [debouncedValue, setDebouncedValue] = react.useState(value);
    const debounce = useDebounce.useDebounce({
        callback: setDebouncedValue,
        delay
    });
    react.useEffect(()=>{
        debounce(value);
    }, [
        value,
        debounce
    ]);
    return debouncedValue;
}

exports.useDebounceValue = useDebounceValue;
//# sourceMappingURL=useDebounceValue.js.map
